import {ChangeDetectionStrategy, Component, computed, inject, input} from '@angular/core';
import {CareproviderUnitService} from '../../../../../../services/careprovider-unit.service';
import {ToolsService} from '../../../../../../services/tools.service';
import {DLPageTypeEnum} from '../../../../../../enums/DataLayerEnums';
import {EventActionEnum, EventCategoryEnum} from '../../../../../../enums/GaTrackingEnums';
import {WindowSizeService} from '../../../../../../services/window-size.service';

@Component({
  selector: 'app-cpru-top-info-short',
  templateUrl: './cpru-top-info-short.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class:
      'relative w-screen ml-[-50vw] left-1/2 xl:w-full xl:ml-0 xl:left-0 care-service-info-top xl:rounded-lg border border-duck-blue-9 bg-duck-blue-10 p-3 lg:p-4 flex justify-between items-center gap-3 lg:p-4',
  },
})
export class CpruTopInfoShortComponent {
  public pageType = input<DLPageTypeEnum>(null);
  protected readonly eventCategoryEnum = EventCategoryEnum;
  protected readonly eventActionEnum = EventActionEnum;
  protected readonly dLPageTypeEnum = DLPageTypeEnum;
  private careproviderUnitService = inject(CareproviderUnitService);
  protected careproviderUnit = this.careproviderUnitService.careproviderUnit;
  public logoUrl = computed<string>(() => {
    if (!this.careproviderUnit().caregiverUnitImages || !this.careproviderUnit().caregiverUnitImages.logoUrl) {
      return null;
    }
    return this.tools.getImageUrl(this.careproviderUnit().caregiverUnitImages.logoUrl);
  });
  protected displayBookingBtn = this.careproviderUnitService.displayBookingBtn;
  protected bookingConfigurationData = this.careproviderUnitService.bookingConfigurationData;
  protected featureLabel = this.careproviderUnitService.featureLabel;
  protected isHsa = this.careproviderUnitService.isHsa;
  private windowSize = inject(WindowSizeService);
  private size = this.windowSize.windowSize;
  private readonly mobileTabsThreshold = 992;
  protected isMobile = computed<boolean>(() => this.size()[0] < this.mobileTabsThreshold);
  constructor(private tools: ToolsService) {}
}
